import React from "react";

/**
 *
 */
type Data = {
    id : string
    name : string
    defaultValue : string
    required : boolean
    min : number
    max : number
    placeholder : string
}

/**
 *
 * @param id
 * @param name
 * @param defaultValue
 * @param required
 * @param min
 * @param max
 * @param placeholder
 * @constructor
 */
export default function Integer({ id, name, defaultValue, required, min, max, placeholder } : Data) {
    // render
    return (
        <input
            className="form-control"
            type="number"
            min={min}
            max={max}
            step="1"
            id={id}
            name={name}
            placeholder={placeholder}
            defaultValue={defaultValue}
            required={required}
        />
    );
}